module.exports = __webpack_public_path__ + "static/media/scop_logo.358e74fa.png";